var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row form-group"},[_c('button',{staticClass:"btn btn-primary form-group",staticStyle:{"padding-left":"12px"},attrs:{"type":"button"}},[_c('span',[_vm._v(_vm._s(_vm.$t("Lbl_EMPBE_GetVerificationCode")))])]),_c('textbox',{attrs:{"placeholder":_vm.$t('lbl_emp2_VerificationCode'),"type":"number"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }